export default __webpack_public_path__ + "8dc43674b59f346182611e7901239fd1.png";